import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { User } from '../entities/authentication/user';
import { BehaviorSubject, Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TableStateService } from '../services/table-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;

  constructor(
    private router: Router,
    private httpService: HttpclientService,
    private tableStateService: TableStateService
  ) {
    const userString = localStorage.getItem('user');
    const userObject =
      userString !== null ? JSON.parse(userString) : new User();
    this.userSubject = new BehaviorSubject<User>(userObject);
    this.user = this.userSubject.asObservable();
  }

  public get userValue() {
    return this.userSubject.value;
  }

  login(username: string, password: string) {
    this.httpService.authenticate(username, password).subscribe((user) => {
      if (user.token) {
        localStorage.setItem('user', JSON.stringify(user));
        this.userSubject.next(user);
        this.router.navigate(['/admin']);
      }
    });
  }

   currentUser() {
    let token = localStorage.getItem('token');
    if (!token) return null;

    return new JwtHelperService().decodeToken(token);
  }

  logout() {
    // Clear all filters and table states
    this.clearAllFilters();
    
    // Clear all localStorage (includes authentication data)
    localStorage.clear();
    
    // Clear authentication-related sessionStorage
    sessionStorage.removeItem('token');

    // remove user from local storage to log user out
    // localStorage.removeItem('user');
    // this.userSubject.next(new User());
    // this.router.navigate(['/login']);
  }

  /**
   * Clear all filters from localStorage and sessionStorage
   */
  private clearAllFilters(): void {
    // Clear table state history and table states
    localStorage.removeItem('tableStateHistory');
    this.tableStateService?.clearAllStates();
    
    // Clear filter-related localStorage items
    localStorage.removeItem('filter');
    localStorage.removeItem('tabs');
    localStorage.removeItem('tabHistory');
    
    // Clear filter-related sessionStorage items
    sessionStorage.removeItem('productFilters');
    sessionStorage.removeItem('redirectNav');
    
    // Clear all table_state_* keys from sessionStorage (if any remain)
    try {
      const keysToRemove: string[] = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith('table_state_')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => sessionStorage.removeItem(key));
    } catch (error) {
      console.error('Error clearing table state keys from sessionStorage:', error);
    }
  }
}
